import { constants } from './utils/asistencia-chat.const';
import { ChatService } from './services/chat.service';
import { MessageFormComponent } from './components/message-form/message-form.component';


import { Message } from './models/message';
import {
  Component, OnInit, OnDestroy, HostListener, AfterContentInit, ViewChild, Input
} from '@angular/core';

import { timer, Subscription, from } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { alissMensajes } from './utils/aliss-mensajes';


import { PushNotificationsService } from 'ng-push-ivy';
import { LocalStorageService } from '../../services/local-storage.service';
import { Contexto } from '../../models/contexto';


import { MatDialog } from '@angular/material/dialog';
import { VentanaUtils } from '../../utils/ventana.utils';
import { InformModalComponent } from '../inform-modal/inform-modal.component';
import { ConciergeService } from '../../services/concierge.service';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';



@Component({
  selector: 'app-asistencia-chat',
  templateUrl: './asistencia-chat.component.html',
  styleUrls: ['./asistencia-chat.component.scss']
})
export class AsistenciaChatComponent implements OnInit, AfterContentInit, OnDestroy {

  /**
   *  Constructor
   * @param conciergeService Servicios de concerge (askForHandler, horario) 
   * @param rest Servicios utilizados para Chatear (ej.: sendMessage, poll, etc.)
   * @param localstorage local-storage del navegador
   * @param pushNotifications Servicio de notificacion
   * @param dialog Dialogo de confirmacion para cierre de ventana
   * @param window Utilitario para manejar el despliegue de la ventana y el iframe contendor
   */
  constructor(public conciergeService: ConciergeService,
    public rest: ChatService,
    private localstorage: LocalStorageService,
    private pushNotifications: PushNotificationsService,
    public dialog: MatDialog,
    private window: VentanaUtils
  ) {
    console.log(">>>>> AsistenciaChatComponent.constructor():: this.messages: %s / this.localstorage.existsPartcipantID(): %s",
      (this.messages) ? JSON.stringify(this.messages) : this.messages, this.localstorage.existsPartcipantID());

  }

  subscriptionIni: Subscription;
  subscription: Subscription;
  subscriptionFin: Subscription;
  subscriptionHand: Subscription;
  subscriptionQueue: Subscription;
  subscriptionHr: Subscription;
  statusText: any;
  polltime = environment.pollTime;
  systemMessageType = alissMensajes.systemType;
  maxqueue: number;
  timeoutHistQueue: boolean;

  public participantID: string;
  public agenteAssigned: string;
  // tslint:disable-next-line: member-ordering
  public message: Message;
  // tslint:disable-next-line: member-ordering
  public messages: Message[] = [];
  public agentTyping: boolean;
  page: number;
  initChat: boolean;
  isTimeout: boolean;
  public handlerType: string;
  public agentesDisponibles: boolean;

  posMensajeSinAgentes: number;
  public mensajesGuardados: Message[] = [];
  public positionQueue = 0;

  @Input() public ctx: Contexto;
  @ViewChild(MessageFormComponent, { static: true }) form: MessageFormComponent;

  // variable utilizada para detectar la navegacion a otro servicio que tambien tiene chat
  // (cuando hay conversacion activa)
  public cambioDeServicio: boolean;

  public fueraHorario: boolean;

  /**
   * Metodo inicializador
   */
  ngOnInit() {
    // Siempres se asume que el usuario no navego a otro servicio (esto se chequeea en validarChatActivo())
    this.cambioDeServicio = false;

    // ----------- Traido desde constructor ----- begin
    this.pushNotifications.requestPermission();
    this.message = new Message('', 'assets/images/user.png', '');
    if (this.localstorage.existsPartcipantID()) {
      this.rest.estadoChat(this.localstorage.getParticipantID(),
        this.localstorage.getUserSession()).pipe(take(1)).subscribe((resp) => {
          console.log(">>>>> AsistenciaChatComponent.estadoChat():: resp: %s",
            (resp) ? JSON.stringify(resp) : resp);
          this.validarChatActivo(resp);
        });
    } else {
      this.despliegaMensajeDeBienvenida();

      this.ctx.interactionInfo.participantId = '';
      this.ctx.interactionInfo.agentName = '';
      this.localstorage.cleanStorage();
    }
    // ----------- Traido desde constructor ----- end
    this.initChat = false;
    this.isTimeout = false;
    this.agentesDisponibles = true;
    this.maxqueue = this.localstorage.getMaxQueue();
    this.localstorage.setHandlerType('chat');
    console.log("AsistenciaChatComponent.ngOnInit():: this.messages: %s / this.subscription: %s",
      (this.messages) ? JSON.stringify(this.messages) : this.messages, this.subscription);

    // remover comentario
    // Asigna ID de servicio que existe en contexto para no perder del local storage 
    // relacionado con el control de navegar a otro servicio que tenga chat 
    //this.localstorage.setServiceID(this.ctx.idServicio);

  }


  /**
   *  Despliega el mensaje automatico de bienvenida cuando se abre la ventana.
   */
  despliegaMensajeDeBienvenida() {

    this.subscriptionHr = this.conciergeService.horarioAtencionServicio(this.ctx).pipe(take(1)).subscribe((resp) => {
      console.log('">>>>> AsistenciaChatComponent.horarioAtencionServicio():: resp: %s',
        (resp) ? JSON.stringify(resp) : resp);
      this.fueraHorario = resp.fueraHorario;
      this.messages = [
        new Message(resp.interactionInfo.welcomeMsg,
          'assets/images/v2-saluda_5s.gif', '', new Date(), false, true)
      ];
    });
  }



  consultarCola() {
    this.posMensajeSinAgentes = this.messages.length;
    this.subscriptionQueue = timer(0, this.polltime).pipe(
      switchMap(() => this.rest.getConsultarCola(this.ctx))
    ).subscribe((response) => {
      // statusCode es el codigo HTTP que puede dar 200 (ok),
      // se valida tambien la respuesta de pureconnect puede ser 'failure' o 'success'
      if (response && response.statusCode === 200 && response.status === 'success') {
        this.agentesDisponibles = response.agentesAvailable;
        if (this.agentesDisponibles) {
          this.iniciarChat();
          this.subscriptionQueue.unsubscribe();
        } else {
          this.messages[this.posMensajeSinAgentes] =
            new Message(response.mensajeNotAvailable, 'assets/images/v2-saluda_5s.gif', '', new Date(), false, true);
        }
      } else {
        this.messages = [new Message(response.statusMessage, 'assets/images/v2-saluda_5s.gif', '', new Date(), false, true)];
        this.subscriptionQueue.unsubscribe();
      }
    });
  }

  ngAfterContentInit() {
    // Utilizado para luego de haber inicializado los componentes, tomar los query param e iniciar el chat
    this.initChat = true;
  }

  iniciarChat() {
    /*
     Si tengo guardado participantId en la sesion actualizo los mensajes,
     sino muestro mensaje inicial e inicio chat
    */

    this.participantID = '';
    this.subscriptionIni = this.rest.getIniciarChat(this.ctx).pipe(take(1)).subscribe((response) => {
      // statusCode es el codigo HTTP que puede dar 200 (ok),
      // se valida tambien la respuesta de pureconnect puede ser 'failure' o 'success'
      if (response && response.statusCode === 200 && response.status === 'success') {
        this.participantID = response.participantID;
        this.maxqueue = response.handlerMaxQueue;
        this.timeoutHistQueue = response.handlerTimeoutHistorical;
        this.localstorage.setParticipantID(this.participantID);
        this.localstorage.setMaxQueue(this.maxqueue);
        // Id de servicio almacenado en el storage para compararlo cuando se navega a otro servicio
        this.localstorage.setServiceID(this.ctx.idServicio);
        this.localstorage.setAsistenteID(this.ctx.codAsistente);
        this.localstorage.setServiceDesc(this.ctx.descServicio);
        // Se guarda la url donde se inicia el chat para poder volver si elige navegar al primer chat
        this.localstorage.setUrlFromChat(this.window.getBaseUrl());

        // Guardamos el usuario de portal que inicio la instancia de chat
        this.localstorage.setUserSession(response.userSession);

        // Nos aseguramos que el contexto tenga el participant ID
        this.ctx.interactionInfo.participantId = response.participantID;

        this.actualizar();
      } else {
        // Error al invocar metodo que inicia conversacion
        this.agentesDisponibles = false;
        this.messages = [new Message(response.statusMessage, 'assets/images/v2-saluda_5s.gif', '', new Date(), false, true)];
      }
    });


  }

  enviarHistorial() {
    this.form.setParticipantIDChild(this.participantID);
    this.form.sendHistoricalMessage();
  }

  /**
   * Valida si hay mensajes disponibles para el usuario.
   * Precondicion: el contexto debe contener un valor valido de participanID
   */
  actualizar() {
    console.log(">>>>> AsistenciaChatComponent.actualiar():: this.ctx: ", (this.ctx) ? JSON.stringify(this.ctx) : this.ctx);
    this.subscription = timer(0, this.polltime).pipe(
      switchMap(() => this.rest.actualizarChat(this.ctx))
    ).subscribe((response) => {

      if (!(response === undefined)) {
        // statusCode es el codigo HTTP que puede dar 200 (ok),
        // se valida tambien la respuesta de pureconnect puede ser 'failure' o 'success'
        if (response && response.statusCode === 200 && response.status === 'success') {
          console.log('actualizarChat():: response.statusCode: %s , response.status: %s , contexto: %s', response.statusCode, response.status, JSON.stringify(this.ctx));
          this.procesarRespuesta(response);
          // Se valida que la respuesta failure sea de tipo que no existe mas la sesion
        } else if (response && response.statusCode === 200
          && response.status === 'failure'
          && response.reason === 'error.websvc.unknownEntity.session'
        ) {
          console.log('actualizarChat():: Detectó que no existe más la sesion en pureconnect');

          // Debe finalizar chat
          this.finalizarChat();

          // No hacer cleanStorage para contemplar manejo de chats en multiples pestañas
          // Se muestra mensaje al usuario indicando chat finalizado. Este escenario se da cuando se abre 
          // otro chat en otra pestaña y se finaliza
          this.messages.push(new Message(alissMensajes.conversacionFinalizada, 'assets/images/bps-avatar.png',
            '', new Date(), false, true, 0, 0));
          this.pintarNuevoMensaje();

          // Se deshabilitar el ingreso de texto
          // y boton de envio; la variable this.agentesDisponibles lo deshabilita
          this.agentesDisponibles = false;
          this.subscription.unsubscribe();
        }
      }
    });
  }


  pushNotify(content) {
    const options = {
      body: content,
      icon: 'assets/images/user.png'
    };
    this.pushNotifications.create(alissMensajes.notificacion, options).subscribe(
      res => {
        switch (res.event.type) {
          case 'click': {
            window.focus();
            res.notification.close();
            break;
          }
          case 'show': {
            const audio = new Audio();
            audio.src = 'assets/sound/alert.wav';
            audio.load();
            audio.play();
            break;
          }
        }
      }
    );
  }

  /**
   * Procesa el mensaje que se recibe desde el asesor.
   * @param result 
   */
  procesarRespuesta(result: any) {
    if (this.agentesDisponibles) {
      this.posMensajeSinAgentes = this.messages.length;
    }

    // Hay un agente disponible y asignado
    if (result.agentName != null) {
      this.agenteAssigned = result.agentName;
      this.localstorage.setAgenteAssigned(this.agenteAssigned);
      // Se agrega al contexto el nombre del agente (se utiliza para personalizar el mensaje de alerta de timout)
      // TODO: Validar informacion del contexto y la info. del localstorage
      this.ctx.interactionInfo.agentName = result.agentName;

      this.agentesDisponibles = true;
      // una vez asignado el agente, se envian todos los mensajes guardados (incluyendo el historial si dio timeout)
      this.enviarHistorial();
    }
    if (!result.isAgentDisconnected) {
      if (!(result.messages === undefined) && Array.isArray(result.messages) && result.messages.length) {
        for (const msj of result.messages) {
          const systemType = (msj.messageType === this.systemMessageType);
          this.isTimeout = msj.isTimeout;
          this.localstorage.setTimeout(this.isTimeout);

          // Se desconecta por inactividad (TIMEOUT)
          if (msj.isTimeout) {
            this.desconectarChat(result);

            // Todos los agentes se encuentran ocupados
          } else if (msj.isAgentBuzy) {
            this.positionQueue = msj.positionQueue !== null ? msj.positionQueue : '';
            this.agentesDisponibles = false;
            // TODO: revisar este caso; comparacion  posicionQueue <= maximo se realiza en el backend
            if (this.positionQueue <= this.maxqueue) {
              // Limpia el textArea
              this.message = new Message('', 'assets/images/user.png', '');
              this.messages[this.posMensajeSinAgentes] = new Message(msj.content, 'assets/images/bps-avatar.png',
                '', new Date(), false, systemType, msj.seqConversation, 0);

            } else {
              this.messages.push(new Message(msj.content, 'assets/images/bps-avatar.png',
                '', new Date(), false, systemType, msj.seqConversation, 0));

              this.pintarNuevoMensaje();
              this.positionQueue = 0;
              this.ngOnDestroy();
              // Se necesita un break para evitar despliegue doble de mensajes (escenario maxqueue=0 y no contestar)
              break;
            }
          } else {
            this.messages.push(new Message(msj.content, 'assets/images/bps-avatar.png',
              '', new Date(), false, systemType, msj.seqConversation, 0));
            this.pintarNuevoMensaje();
            // Si es de agente
            if (!systemType) {
              this.pushNotify(msj.content);
            }
          }
        }
      }
      // Consultamos si hay eventos de tipeo en la respuesta
      if (!(result.typingEvent === undefined) && Array.isArray(result.typingEvent) && result.typingEvent.length) {
        for (const typing of result.typingEvent) {
          this.agentTyping = Boolean(JSON.parse(typing.isTyping));
        }
      }
    } else {
      // si el agente se desconectó, muestro los mensajes que quedaron pendientes del poll
      if (!(result.messages === undefined) && Array.isArray(result.messages) && result.messages.length) {
        for (const msj of result.messages) {
          this.messages.push(new Message(msj.content, 'assets/images/bps-avatar.png',
            '', new Date(), false, this.message.system, msj.seqConversation, 0));
          this.pintarNuevoMensaje();
        }
      }
      // Esta desconectado 1. despliego mensaje de desconexion
      this.desconectarChat(result);

      // Si el Asesor se desconecta, entonces se deshabilitar el ingreso de texto
      // y boton de envio; la variable this.agentesDisponibles lo deshabilita
      this.agentesDisponibles = false;
    }

  }

  pintarNuevoMensaje() {
    if (this.localstorage.getWindowStatus() === 'min') {
      this.window.styleNewMessage();
    }
  }

  /**
   * Valida si el CHAT se encuentra activo.
   * IMPORTANTE: Este metodo es invocado desde el constructor del componente; significa que atributos que se inyectan aun no tienen su valor,
   * por ejemplo: this.ctx (es undefined en este momento y toma su valor despues del ngOnInit()
   * 
   * @param {json} response respuesta del servicio /status
   */
  validarChatActivo(response) {
    const chatActivo = (response.status === constants.CHAT_ACTIVO);
    const detectoCambioUsuario = (response.reason === constants.CAMBIO_USUARIO);
    console.log("validarChatActivo():: chatActivo: %s", chatActivo);
    console.log("validarChatActivo():: this.localstorage.getMessages(): %s",
      (this.localstorage.getMessages()) ? JSON.stringify(this.localstorage.getMessages()) : this.localstorage.getMessages());

    if (chatActivo) {
      this.messages = this.localstorage.getMessages();
      this.participantID = this.localstorage.getParticipantID();
      this.agenteAssigned = this.localstorage.getAgenteAssigned();
      // Antes de actualizar aseguramos que el participantID se encuentre en el contexto
      this.ctx.interactionInfo.participantId = this.localstorage.getParticipantID();


      //TODO: Continuar la logica de control de multiples ventanas en servicios distintos
      // NOTA: this.ctx es undefined porque es llamado desde constructor.
      //      if (this.localstorage.getServiceID() === this.ctx.idServicio) {
      if (this.localstorage.getAsistenteID() === this.ctx.codAsistente) {
        // Se ingresa a otro servicio que tiene CHAT, habiendo una conversacion activa
        // La ventana de chat se abre
        console.log('validarChatActivo()::ALERTA:: ID IGUALES / id localstorage: %s , ctx.idServicio: %s, localstorage AsistenteID: %s, ctx.codAsistente: %s',
          this.localstorage.getServiceID(), this.ctx.idServicio, this.localstorage.getAsistenteID(), this.ctx.codAsistente);

        // Debe actualizar
        this.actualizar();
      } else {
        console.log('validarChatActivo()::ALERTA:: ID DISTINTOS / id localstorage: %s , ctx.idServicio: %s, localstorage AsistenteID: %s, ctx.codAsistente: %s',
          this.localstorage.getServiceID(), this.ctx.idServicio, this.localstorage.getAsistenteID(), this.ctx.codAsistente);

        // este atributo en true deshabilita el area de texto para el mensaje
        this.cambioDeServicio = true;
        // Se reemplaza 'DESC_SERV' en la frase warningOtroServicio
        let re = /DESC_SERV/gi;
        let mensaje = alissMensajes.warningOtroServicio.replace(re, this.localstorage.getServiceDesc());

        // Apertura del dialogo cuando hay cambio de servicio
        // Usa como panel Class la isma del dialogo
        const dialogRef = this.dialog.open(ConfirmModalComponent, {
          data: { message: mensaje, btnNOK: 'Finalizar el chat anterior e iniciar uno nuevo', btnOK: 'Regresar al chat anterior' },
          panelClass: 'custom-inform-modalbox'
        });

        // Suscriptor para el dialogo
        dialogRef.afterClosed().subscribe(result => {
          if (result && result === ConfirmModalComponent.OK) {
            // Al presionar NO, se navega hacia el servicio con CHAT activo
            /*let baseUrl = this.window.getBaseUrl();
            // se sustituye por el ID de chat activo en la URL
            let urlServicio = this.replaceServiceID(baseUrl, this.localstorage.getServiceID());*/
            let urlServicio = this.localstorage.getUrlFromChat();
            // se navega al servicio correspondiente
            this.window.navigateTo(urlServicio);

          } else {
            // Al presionar SI se inicia un nuevo chat
            this.localstorage.cleanStorage();
            this.finalizarChat();
            this.ngOnInit();

          }
        });


      }

      // chat NO activo
    } else {
      if (detectoCambioUsuario) {
        // Lo seteamos para poder finalizar el chat anterior
        this.participantID = this.localstorage.getParticipantID();
        this.finalizarChat();
      }
      this.localstorage.cleanStorage(); // Este método no limpia el welcomeMessage por lo que no se rompe el siguiente metodo
      this.despliegaMensajeDeBienvenida();
    }
  }

  /**
   * Metodo que reemplaza el ID de servicio de una URL por otro ID dado por parametro.
   * Para identificar el ID adecuado utiliza el nombre del parametro ('srvext')
   * 
   * @param baseUrl URL dada
   * @param idServicio  ID de servicio usado para sustituir
   */
  replaceServiceID(baseUrl: string, idServicio: string): string {
    // Inicializa URL igual que la anterior
    let resultUrl = baseUrl;

    // Posicion inicial del string a reemplazar
    let idParam = baseUrl.indexOf('srvext=');
    if (idParam != -1) {
      let idxT0 = idParam + 7;

      let targetStr = baseUrl.substring(idxT0, baseUrl.length);
      let idxTN = targetStr.indexOf('&');
      if (idxTN && idxTN != -1) {
        // hay mas parametros despues de srvext en la URL
        let char2replace = targetStr.substring(0, idxTN);
        resultUrl = baseUrl.replace(char2replace, idServicio);
      } else {
        // srvext es el ultimo parametro en la URL
        let char2replace = targetStr;
        resultUrl = baseUrl.replace(char2replace, idServicio);
      }
    }
    console.log("URL origen: %s / URL destino", baseUrl, resultUrl);

    return resultUrl;
  }


  desconectarChat(result) {
    // Se desconecta por timeout
    this.messages.push(new Message(result.mensajeDesconexion, 'assets/images/bps-avatar.png',
      '', new Date(), false, true, 0, 0));
    this.pintarNuevoMensaje();

    // finalizo sesion
    this.ngOnDestroy();
  }

  /**
   * Finaliza el CHAT
   */
  finalizarChat() {
    if (this.participantID) {
      this.subscriptionFin = this.rest.finalizarChat(this.participantID).pipe(take(1)).subscribe((response) => {
        console.log("AsistenciaChatComponent.finalizarChat():: response %s", response);
        // remueve el participanID desde el localstorage si estoy cerrando el chat de la ventana activa (multiples pestañas)
        if (this.localstorage.getServiceID() === this.ctx.idServicio) {
          this.localstorage.removeParticipantID();
        }
        this.participantID = undefined;
      });
    }
  }

  showAsistantIcon(idElement) {
    window.parent.document.getElementById(idElement).style.display = 'block';
  }

  ngOnDestroy() {
    this.finalizarChat();

    /*
     * Si sale por timeout, guardo en localstorage el historial de mensajes
     * para enviarlo si el usuario vuelve a escribir para iniciar un nuevo chat 
     * y remuevo el participant ID
     * Esto es configurable.
     * 
     */
    if (this.isTimeout && this.timeoutHistQueue) {
      this.localstorage.setMessages([]);
      this.localstorage.setMessages(this.messages);

      // remuevo participant ID para que al cerrar ventana no me pida confirmacion
      // en el escenario de timeout.
      this.localstorage.removeParticipantID();
    } else {
      // TODO: revisar que se hace en este caso
      // no se puede limpiar el localstorage aca (se hace en el evento de cierre de ventana)

    }
    // Se limpian las variables para mostrar adecuadamente
    this.participantID = '';
    this.agenteAssigned = '';
    this.positionQueue = 0;
    // this.agentesDisponibles = true;
    // limpia el textArea
    this.message = new Message('', 'assets/images/user.png', '');

    if (this.subscription) {
      this.subscription.unsubscribe();
    }

  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    this.saveDataOnWindowsUnload();
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event: Event) {
    this.saveDataOnWindowsUnload();
  }

  saveDataOnWindowsUnload() {
    // Salvamos los mensajes para volver a renderizarlos en la nueva pestaña
    this.localstorage.setMessages([]);
    this.localstorage.setMessages(this.messages);

    // Si no hay conversacion activa (no existe participantID) entonces remuevo Handler
    // y windowStatus del localStorage
    if (!this.localstorage.existsPartcipantID()) {
      this.localstorage.removeHandlerType();
      this.localstorage.removeWindowsStatus();
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    event.returnValue = false;
  }

}
